import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { getCartInfo } from '@/common/service/default-mapper';
import { isEmptyVal } from '@/utils';
import { getVideoSdkUcCode } from '@/plans/VIDEO_SDK_UC/helper/parse';

const videoSdkUcCategoryPrefix = "zsdkuc";

export default (planMapJSON = {}) => {
  /** @type {VideoSdkUcResponseBean} */
  const sdkuc = planMapJSON['zoom_universal_sdk'];

  if (isEmptyVal(sdkuc)) return [];

  return sdkuc.prices.map((p) => {
    return {
      type: planTypes.VIDEO_SDK_UC,
      typeNameKey: 'billing.video_sdk_uc.title',
      planNameKey: 'billing.video_sdk_uc.title',
      billing_cycle: BILLING_CYCLE.MONTHLY,
      category: `${videoSdkUcCategoryPrefix}${p.credit}`,
      cartInfo: getCartInfo(),
      credit: p.credit,
      amount: p.price,
      plan_code: getVideoSdkUcCode(sdkuc.plan_code, p.quantity),
      handlerParsePlanCode: () => sdkuc.plan_code,
      parent_category: 'ZSDKUC',
      supportCoupon: false,
      dependBasePlanTypeList: [],
    };
  }) || [];
}



